import { render, staticRenderFns } from "./ProfileCreate.vue?vue&type=template&id=83fc5336&"
import script from "./ProfileCreate.vue?vue&type=script&lang=js&"
export * from "./ProfileCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports